<template>
    <div class="rall" v-if="vinfo">
        <headerNav title="话题正文" />
        <div class="rmain">
           <comrecommend :showalloperate="false"  :showonly="10" :item="vinfo" ></comrecommend>
        </div>
        <div class="commentlist">
            <div class="mainlist">
                <div class="commentlist-mtit" v-if="totalnum">
                    <span class="commentlist-tit">所有评论</span>
                    <span>{{totalnum}}</span>
                </div>
                  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                    <van-list
                    v-model="navitem.loaded"
                    :finished="navitem.loadingType == 'nomore' ? true : false"
                    @load="loadData"
                    >
                        <div v-for="(item,index) in navitem.list" :key="index">
                            <comment :item="item" @like="like"  :vindex="1"></comment>
                        </div>
                    </van-list>
                 </van-pull-refresh>
            </div>
        </div>
        <div class="qfooter" @click="gotocomment()">
            <div >
               <van-icon
                    class="answerlist-icon-icon3"
                    :size="18"
                    class-prefix="abc-icon"
                    name="xieru"
                />
                <span class="qfooter-tit">我来评论</span>
            </div>
        </div>
    </div>
</template>
<script>
import comrecommend from '@/components/common/recommend/comrecommend.vue';
import alloperate from '@/components/common/recommend/alloperate.vue';
import comment from '@/components/common/comment/comment.vue';
export default {
    components:{
        comrecommend,
        alloperate,
        comment
    },
    data(){
        return {
            vinfo:undefined,
            vid:undefined,
            navitem: {
                loadingType: "more",
                loaded: false,
                getparams: {
                    sorting: "",
                    maxResultCount: 10,
                    skipCount: 0,
                    topicId:undefined,
                    isNeedChild:true,
                    isHasReplyCommentId:true
                },
                list: [],
            },
            showonly:10,
            loading: false,
            finished: false,
            refreshing: false,
            totalnum:undefined
        }
    },
    created(){
        var query=this.$route.query;
        var item=JSON.parse(query.item);
        this.vinfo=item;
        this.navitem.getparams.topicId=this.vinfo.id;
    },
    methods:{
    gotocomment()
    {
        this.$router.push({path:'/addrecomment',query:{topicId:this.vinfo.id}});
    },
    onRefresh() {
        this.loadData("refresh");
    },
    like(item)
    {
        var vindex= this.navitem.list.findIndex(x=>x.id==item.id);
        if(!item.isLike)
        {
            var model={
                topicId:item.topicId,
                topicCommentId:item.id
            };
            
            this.ajax.post('/api/services/app/PhoneTopic/LikeTopicComment',model).then(x=>{
                this.navitem.list[vindex].isLike=true;
                this.navitem.list[vindex].giveLikeCount+=1;
            })
        }
        else
        {
            
            this.ajax.post('/api/services/app/PhoneTopic/CancelTopicComment?topicCommentId='+item.id).then(x=> {
                this.navitem.list[vindex].isLike=false;
                this.navitem.list[vindex].giveLikeCount-=1;
            })
        }
        
        
    },
    loadData(source) {
        let navItem = this.navitem;
        
        if (source === "tabChange" && navItem.loaded === true) {
            //tab切换只有第一次需要加载数据
            return;
        }
        if (navItem.loadingType === "loading" || navItem.loadingType === "nomore") {
            //防止重复加载
            if (source != "refresh") {
            return;
            }
        }
        if (source === "refresh") {
            this.navitem.list = [];
            this.navitem.getparams.skipCount = 0;
        }
        navItem.loadingType = "loading";
        var params = navItem.getparams;
        //加载数据
        this.ajax
            .post("/api/services/app/PhoneTopic/QueryTopicCommentList", params)
            .then((x) => {
            this.navitem.getparams.skipCount += this.navitem.getparams.maxResultCount;
            let totalcount = x.result.totalCount;
            this.totalnum=x.result.totalCount;
            this.navitem.list = this.navitem.list.concat(x.result.items);
            //console.log(this.navList);
            // item = Object.assign(item, this.orderStateExp(item.state));
            this.navitem.loadingType =
                totalcount > this.navitem.getparams.skipCount ? "more" : "nomore";
            })
            .finally(() => {
            this.$set(this.navitem, "loaded", false);
            this.refreshing = false;
            });
        },
    }
}
</script>
<style lang="scss" scoped>
.rall{
    font-size: 12px;
}
.rfooter{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    font-size: 14px;
    padding-top:8px;
    padding-bottom: 5px;
}
.mainlist{
    margin-top:5px;
    margin: 10px;
    margin-bottom: 45px;
}
.commentlist{
    margin-top:10px;
    background-color: #fff;
    margin-bottom: 50px;
}
.commentlist-mtit{
    padding:10px 0;
    font-size: 14px;
}
.commentlist-tit{
    margin-right: 10px;
}
.qfooter{
    position: fixed;
    bottom: 0;
    left:0;
    right:0;
    background-color: #fff;
    text-align: center;
    padding: 15px;
    font-size: 15px;
    color:#e4c469;
    border-top:1px solid #e6e6e6;
    .qfooter-tit{
        margin-left:5px;
    }
}
</style>